// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/play.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function PlayIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M4.89941 1.375C5.25195 1.375 5.59703 1.48015 5.88965 1.67676L13.0801 6.50781C13.577 6.8418 13.875 7.40127 13.875 8C13.875 8.59873 13.577 9.1582 13.0801 9.49219L5.88965 14.3232C5.59703 14.5198 5.25195 14.625 4.89941 14.625C3.91949 14.6249 3.12513 13.8305 3.125 12.8506V3.14941C3.12513 2.16949 3.91949 1.37513 4.89941 1.375ZM4.89941 2.625C4.60985 2.62513 4.37513 2.85985 4.375 3.14941V12.8506C4.37513 13.1402 4.60985 13.3749 4.89941 13.375C5.00362 13.375 5.10588 13.3442 5.19238 13.2861L12.3828 8.45508C12.5343 8.35331 12.625 8.18249 12.625 8C12.625 7.81751 12.5343 7.6467 12.3828 7.54492L5.19238 2.71387C5.10588 2.65576 5.00362 2.625 4.89941 2.625Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
